import React from 'react';
import {
  PiFileTextLight,
  PiUserPlusLight,
  PiUserMinusLight,
  PiArrowsLeftRightLight,
  PiFlagLight,
  PiCalendarBlankLight,
  PiCheckCircleLight,
  PiTargetLight,
  PiWarningLight,
  PiNoteLight,
} from 'react-icons/pi';
import { formatEventType } from '../../../utils/functions';

/**
 * How an event_type reads: its glyph and its badge colour. Kept apart from
 * FeedEventItem so the activity/audit surfaces can reuse the same vocabulary.
 */

type BadgeColor = 'blue' | 'green' | 'red' | 'purple' | 'orange' | 'yellow' | 'gray';

export const feedEventGlyph = (eventType: string): React.ReactNode => {
  switch (eventType) {
    case 'team_created':
    case 'department_created':
    case 'task_created':
      return <PiFileTextLight />;
    case 'member_added':
    case 'collaborator_added':
      return <PiUserPlusLight />;
    case 'member_removed':
    case 'collaborator_removed':
      return <PiUserMinusLight />;
    case 'status_changed':
      return <PiArrowsLeftRightLight />;
    case 'priority_changed':
      return <PiFlagLight />;
    case 'due_date_changed':
      return <PiCalendarBlankLight />;
    case 'description_updated':
    case 'update':
      return <PiCheckCircleLight />;
    case 'milestone':
      return <PiTargetLight />;
    case 'issue':
      return <PiWarningLight />;
    case 'note':
      return <PiNoteLight />;
    case 'action':
      return <PiCheckCircleLight />;
    default:
      return <PiFileTextLight />;
  }
};

export const feedEventBadgeColor = (eventType: string): BadgeColor => {
  switch (eventType) {
    case 'team_created':
    case 'department_created':
    case 'task_created':
    case 'milestone':
      return 'blue';
    case 'member_added':
    case 'collaborator_added':
    case 'action':
      return 'green';
    case 'member_removed':
    case 'collaborator_removed':
      return 'red';
    case 'description_updated':
    case 'update':
    case 'status_changed':
      return 'purple';
    case 'priority_changed':
    case 'issue':
      return 'orange';
    case 'due_date_changed':
      return 'yellow';
    default:
      return 'gray';
  }
};

export const feedEventLabel = (eventType: string): string => formatEventType(eventType);
